module.exports = __webpack_public_path__ + "assets/img/familyCrest-6edc787f.png";